const stepperValues = {
  'dados-pessoais': {
    title: 'Dados pessoais',
    stepNumber: '1',
    stepNumberFGTS: '1'
  },
  'verificacao-codigo-sms': {
    title: 'Token',
    stepNumber: '5',
    stepNumberFGTS: '2'
  },
  'enviar-codigo-sms': {
    title: 'Token',
    stepNumber: '5',
    stepNumberFGTS: '2'
  },
  'valor-desejado': {
    title: 'Valor do empréstimo',
    stepNumber: '2'
  },
  'valor-desejado/customizar': {
    title: 'Valor do empréstimo',
    stepNumber: '2'
  },
  profissao: {
    title: 'Fonte de renda',
    stepNumber: '3'
  },
  'fonte-de-renda': {
    title: 'Fonte de renda',
    stepNumber: '3'
  },
  'motivo-emprestimo': {
    title: 'Motivo do empréstimo',
    stepNumber: '4'
  },
  'dados-imovel': {
    title: 'Imóvel',
    stepNumber: '6'
  },
  'dados-imovel/customizar': {
    title: 'Imóvel',
    stepNumber: '6'
  },
  'dados-imovel-indisponivel': {
    title: 'Imóvel',
    stepNumber: '6'
  },
  'dados-pessoais-formalizacao': {
    title: 'Dados pessoais',
    stepNumber: '1',
    stepNumberFGTS: '1'
  },
  'formalizacao-documento': {
    title: 'Documento',
    stepNumber: '2',
    stepNumberFGTS: '2'
  },
  'endereco-residencial': {
    title: 'Endereço',
    stepNumber: '3',
    stepNumberFGTS: '3'
  },
  'dados-bancarios': {
    title: 'Dados bancários',
    stepNumber: '4',
    stepNumberFGTS: '4'
  },
  'emprestimo-recorrente': {
    title: 'Opção de empréstimo',
    stepNumber: '4'
  },
  objetivo: {
    title: 'Objetivo',
    stepNumber: '5',
    stepNumberFGTS: '5'
  },
  'dados-vendedor': {
    title: 'Dados do vendedor',
    stepNumber: '5',
    stepNumberFGTS: '5'
  }
}

export default stepperValues
